import { useHasAlertsFeature } from 'portal/src/hooks/useHasAlertsFeature';
import PageWithHeader from 'portal/src/layouts/base/PageWithHeader';
import forbiddenResponse from 'portal/src/navigation/responses/forbiddenResponse';

import AlertsTable from './AlertsTable';

export default function AlertsPage() {
  const hasAlertsFeature = useHasAlertsFeature();

  if (!hasAlertsFeature) {
    throw forbiddenResponse();
  }

  return (
    <PageWithHeader title="Alerts">
      <AlertsTable />
    </PageWithHeader>
  );
}
